import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EPromoDetailsActionTypes {
  OpenDetails = 'PROMO_DETAILS/OPEN_MODAL',
  CloseDetails = 'PROMO_DETAILS/CLOSE_MODAL',
}

export type TOpenPromoDetails = ITypedReduxAction<EPromoDetailsActionTypes.OpenDetails, string>;
export type TClosePromoDetails = ITypedReduxAction<EPromoDetailsActionTypes.CloseDetails>;

/**
 * Создает Redux action, который открывает модальное окно с подробной информацией об акции
 *
 * @param {string} payload - id акции
 */
export const openPromoDetails = actionGenerator<EPromoDetailsActionTypes.OpenDetails, string>(
  EPromoDetailsActionTypes.OpenDetails,
);

/**
 * Создает Redux action, который закрывает модальное окно с подробной информацией об акции
 */
export const closePromoDetails = actionGenerator<EPromoDetailsActionTypes.CloseDetails>(
  EPromoDetailsActionTypes.CloseDetails,
);

export type TPromoDetailsActions = TOpenPromoDetails | TClosePromoDetails;
